export const mapsApiKey = 'AIzaSyAM45Y3qg0IiOLMZNuGrkoHhSyIBBr8LLU';
const MAPS_CALLBACK = 'initMap';

export const captchaApiKey = '6Ld4GS8UAAAAAGVXD5tZLGCQukb9pq9jlYjV9_vd';
const CAPTCHA_CALLBACK = 'onloadCallback';

// * https://developers.google.com/maps/documentation/javascript/tutorial#Loading_the_Maps_API

export const scriptsConfig = {
	maps: {
		baseUrl: 'https://maps.googleapis.com/maps/api/js',
		type: 'google',
		callback: MAPS_CALLBACK,
		params: {
			key: mapsApiKey,
			libraries: 'geometry,places',
			version: '3.41',
			callback: MAPS_CALLBACK,
		},
	},
	captcha: {
		baseUrl: 'https://www.google.com/recaptcha/api.js',
		type: 'grecaptcha',
		callback: CAPTCHA_CALLBACK,
		params: {
			onload: CAPTCHA_CALLBACK,
			render: 'explicit',
		},
	},
};
